import { createSlice } from "@reduxjs/toolkit";

const getInitialMode = () => {
  try {
    return localStorage.getItem("theme") ?? "dark";
  } catch (_) {
    return "dark";
  }
};

const getInitialKendoTheme = () => {
  try {
    return localStorage.getItem("kendoTheme") ?? null; // null = oto (mode ile sync)
  } catch (_) {
    return null;
  }
};

const themeSlice = createSlice({
  name: "theme",
  initialState: { mode: getInitialMode(), kendoTheme: getInitialKendoTheme() },
  reducers: {
    toggleTheme(state) {
      state.mode = state.mode === "dark" ? "light" : "dark";
      try {
        localStorage.setItem("theme", state.mode);
      } catch (_) {}
    },
    setTheme(state, action) {
      state.mode = action.payload;
      try {
        localStorage.setItem("theme", action.payload);
      } catch (_) {}
    },
    setKendoTheme(state, action) {
      // null = oto mod (app dark/light ile sync)
      state.kendoTheme = action.payload;
      try {
        if (action.payload) {
          localStorage.setItem("kendoTheme", action.payload);
        } else {
          localStorage.removeItem("kendoTheme");
        }
      } catch (_) {}
    },
  },
});

export const themeActions = themeSlice.actions;
export const themeReducer = themeSlice.reducer;
